import './index.scss'
import {Dialog, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@mui/material";
import BidItem from "./BidItem";
import Paper from '@mui/material/Paper';
import {Skeleton} from "@mui/lab";
import TextHelper from "../../../../helpers/textHelper";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {updateDisqualificationReasonDialogData, updateSelectedLines} from "../../../../store/slice/bidComparsionChart";
import DisqualificationReasonDialog from "./DisqualificationReasonDialog";
import RejectDialog from "../bidCard/RejectDialog";
import {CheckBox} from "@mui/icons-material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
// import {makeStyles} from '@mui/styles';
import Tooltip from '@mui/material/Tooltip';
import IconButton from "@mui/material/IconButton";

const BidChart = ({isLoading, setBidMainId}) => {
    const tableCellStyle = {
        borderLeft: "1px solid rgba(224, 224,224,1)",
        borderRight: "1px solid rgba(224, 224,224,1)",
        textAlign: 'left'
    };

    const [rejectDialog, setRejectDialog] = useState(null)

    const dispatch = useDispatch()

    const isForUAE = JSON.parse(process.env.REACT_APP_FOR_UAE)

    const selectedSequenceFromWFA = useSelector((state) => state.bidComparsionSlice.selectedSequenceFromWFA)
    const disqualificationReasonDialogData = useSelector((state) => state.bidComparsionSlice.disqualificationReasonDialogData)
    const chartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)
    const selectedLines = useSelector((state) => state.bidComparsionSlice.selectedLines)
    const closeDisqualificationDialog = () => {
        dispatch(updateDisqualificationReasonDialogData(null))
    }
    const handleChangeCheckBox = (index, rfqDetailId) => {
        const newSelected = {...selectedLines}
        const data = newSelected?.[index]
        if (data && data?.rejectReasonId) {
            delete newSelected[index]
            dispatch(updateSelectedLines(newSelected))
        } else {
            setRejectDialog({status: true, index, rfqDetailId})
        }

    }

    const checkIsDisabled = (index, rfqDetailId) => {
        const bids = chartData?.bids
        let bidApprovals = []
        bids?.forEach(item => {
            bidApprovals = [...bidApprovals, ...item?.bidApprovals?.filter(x => x?.rfqDetailId === rfqDetailId)]
        })
        const bid = bids?.find(item => item?.bidApprovals?.find(x => x?.approveStatus == 2 && x?.rfqDetailId == rfqDetailId))
        const line = bid?.bidApprovals?.find(item => item?.rfqDetailId == rfqDetailId && item?.approveStatus == 2)
        return !line?.bidMainId
    }

    return (
        <div className="bid-comparsion-card">
            <Dialog open={disqualificationReasonDialogData} onClose={closeDisqualificationDialog} fullWidth={true}>
                <DisqualificationReasonDialog/>
            </Dialog>
            <Dialog open={rejectDialog?.status} onClose={() => setRejectDialog(null)} fullWidth={true}>
                <RejectDialog rejectDialog={rejectDialog} setRejectDialog={setRejectDialog}/>
            </Dialog>
            <TableContainer
                style={{zIndex: 1, borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: '1px solid #000'}}
                component={Paper}
                className="static-table">
                <Table size="small">
                    <TableHead>
                        <TableRow className="bg-grey" style={{height: '55px'}}>
                            <TableCell style={tableCellStyle} colspan={9} align="center">
                                <Typography variant="h5" sx={{fontWeight: 'bold'}}>
                                    Request Information
                                </Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow className="bg-grey">
                            <TableCell style={tableCellStyle}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Actions
                                </Typography>
                            </TableCell>
                            <TableCell style={tableCellStyle}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Line
                                </Typography>
                            </TableCell>
                            <TableCell style={tableCellStyle}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Description of Required Purchase
                                </Typography>
                            </TableCell>
                            <TableCell style={tableCellStyle}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    RFQ <br/> Quantity
                                </Typography>
                            </TableCell>
                            <TableCell style={tableCellStyle}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    PUOM
                                </Typography>
                            </TableCell>
                            <TableCell style={tableCellStyle}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Budget
                                </Typography>
                            </TableCell>
                            <TableCell style={tableCellStyle}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Remaining <br/> Budget
                                </Typography>
                            </TableCell>
                            {isForUAE && (
                                <>
                                    <TableCell style={tableCellStyle}>
                                        <Typography sx={{fontWeight: 'bold'}}>
                                            Brand
                                        </Typography>
                                    </TableCell>
                                    <TableCell style={tableCellStyle}>
                                        <Typography sx={{fontWeight: 'bold'}}>
                                            Current <br/> Price
                                        </Typography>
                                    </TableCell>
                                </>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading ? (
                            Array.from({length: 5}).map((_, i) => (
                                <TableRow key={i}>
                                    {Array.from({length: isForUAE ? 9 : 7}).map((_, index) => (
                                        <TableCell style={tableCellStyle} key={index}>
                                            <Skeleton variant="rectangular" width="100%" height={30}/>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))
                        ) : chartData?.rfqDetails?.map((item, index) => (
                            <TableRow hover role="checkbox" tabIndex={-1} key={item?.lineNo}>
                                <TableCell style={tableCellStyle}>
                                    <Tooltip
                                        title={(selectedLines?.[index]?.rejectReasonId && selectedLines?.[index]?.rfqDeatilid == item?.rfqDetailId) || !checkIsDisabled(index, item?.rfqDetailId) ? 'Rejected' : 'Reject'}>
                                        <IconButton style={{padding: '2px'}}>
                                            {(selectedLines?.[index]?.rejectReasonId && selectedLines?.[index]?.rfqDeatilid == item?.rfqDetailId) || !checkIsDisabled(index, item?.rfqDetailId) ? (
                                                <CheckBox
                                                    color={`${!selectedSequenceFromWFA ? 'muted' : !checkIsDisabled(index, item?.rfqDetailId) ? 'muted' : 'error'}`}
                                                    onClick={() => checkIsDisabled(index, item?.rfqDetailId) && selectedSequenceFromWFA && handleChangeCheckBox(index, item?.rfqDetailId)}/>

                                            ) : (
                                                <CheckBoxOutlineBlankIcon
                                                    color={`${!selectedSequenceFromWFA ? 'muted' : !checkIsDisabled(index, item?.rfqDetailId) ? 'muted' : 'error'}`}
                                                    onClick={() => checkIsDisabled(index, item?.rfqDetailId) && selectedSequenceFromWFA && handleChangeCheckBox(index, item?.rfqDetailId)}/>
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                                <TableCell style={tableCellStyle}>{item?.lineNo}</TableCell>
                                <TableCell style={tableCellStyle}>
                                            <span
                                                title={item?.description}>{TextHelper.checkTextLength(item?.description, 20)}</span>
                                </TableCell>
                                <TableCell style={tableCellStyle}>{item?.quantity}</TableCell>
                                <TableCell style={tableCellStyle}>{item?.uom}</TableCell>
                                <TableCell style={tableCellStyle}>{item?.budget}</TableCell>
                                <TableCell style={tableCellStyle}>{item?.remainingBudget}</TableCell>
                                {isForUAE && (
                                    <>
                                        <TableCell style={tableCellStyle}>{item?.brand}</TableCell>
                                        <TableCell style={tableCellStyle}>{item?.currentPrice}</TableCell>
                                    </>
                                )}
                            </TableRow>
                        ))}
                        <TableRow className="bg-grey" role="checkbox" tabIndex={-1}>
                            {Array.from({length: isForUAE ? 9 : 7}).map((_, index) => (
                                <TableCell style={tableCellStyle} key={index}/>
                            ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            {chartData?.bids?.map(item => (
                <BidItem item={item} key={item?.bidMainId}
                         rfqDetails={chartData?.rfqDetails} setBidMainId={setBidMainId}/>
            ))}
        </div>
    )
}

export default BidChart
